import Profile from "./views/profile/Edit.jsx";
import Subscription from "./views/profile/Sub.jsx";
import UserArticles from "./views/profile/Articles.jsx";
import UserForums from "./views/profile/Forums.jsx";
import IconUser from "./components/Icon/User.jsx";
import IconEnvelope from "./components/Icon/Envelope.jsx";
import IconInboxArrowDown from "./components/Icon/InboxArrowDown.jsx";
import IconChat from "./components/Icon/Chat.jsx";
var routes = [
  {
    path: "/profile",
    name: "個人資料",
    icon: IconUser,
    component: Profile,
    layout: "/dash/user",
    roles: [600],
  },
  {
    path: "/subscription",
    name: "訂閱管理",
    icon: IconEnvelope,
    component: Subscription,
    layout: "/dash/user",
    roles: [600],
  },
  {
    path: "/management/articles",
    name: "投稿管理",
    icon: IconInboxArrowDown,
    component: UserArticles,
    layout: "/dash/user",
    roles: [600],
  },
  {
    path: "/management/forums",
    name: "美南論壇",
    icon: IconChat,
    component: UserForums,
    layout: "/dash/user",
    roles: [600],
  },
];
export default routes;
